export const SET_USERINFO = 'SET_USERINFO';
export const SET_LOADING = 'SET_LOADING';
export const SET_AGENT_LIST = 'SET_AGENT_LIST';
export const SET_AGENT_INFO = 'SET_AGENT_INFO';
export const SET_STORE_LIST = 'SET_STORE_LIST';
export const SET_ECU_STORE_LIST = 'SET_ECU_STORE_LIST';



// WEBPACK FOOTER //
// ./src/store/mutations_type.js